// extracted by mini-css-extract-plugin
export default {"folder":"PlayAllCard_folder__71vVV","icon":"PlayAllCard_icon__eOwHA","label":"PlayAllCard_label__5Nn0n"};